module.exports = __webpack_public_path__ + "img/dva-batch-b1.667bc9f7.png";